import { render, staticRenderFns } from "./table-item-popup.vue?vue&type=template&id=3b577e86&lang=pug&"
import script from "./table-item-popup.vue?vue&type=script&lang=ts&"
export * from "./table-item-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports